export interface MangaItem {
  id: number;
  title: string;
  category: string;
  tag: string;
  description: string;
  chapters: number;
  rating: string;
  fans: string;
  progress: string;
  cover: string;
}

export const hotMangaList: MangaItem[] = [
  {
    id: 1,
    title: '星海旅人',
    category: '科幻冒险',
    tag: '太空漫游',
    description: '失忆的少年踏上横跨星海的旅程，在每一颗星球上都藏着关于过去的碎片，也藏着关于未来的答案。',
    chapters: 128,
    rating: '9.4',
    fans: '26.8万',
    progress: '第88话',
    cover: 'https://readdy.ai/api/search-image?query=A%20young%20space%20traveler%20in%20an%20orange%20and%20cream%20futuristic%20jacket%20floating%20among%20colorful%20nebula%20stars%2C%20warm%20golden%20light%2C%20stylized%20manga%20cover%20illustration%2C%20clean%20bold%20linework%2C%20soft%20cream%20background%2C%20energetic%20adventure%20feeling&width=480&height=640&seq=cover-01&orientation=portrait',
  },
  {
    id: 2,
    title: '逆光之刃',
    category: '热血动作',
    tag: '少年冒险',
    description: '背负家仇的剑客少年，在落日余晖下握紧长刃，与宿命一次次对弈，只为守护心中那束不肯熄灭的光。',
    chapters: 96,
    rating: '9.1',
    fans: '21.3万',
    progress: '第64话',
    cover: 'https://readdy.ai/api/search-image?query=A%20determined%20swordsman%20holding%20a%20long%20blade%20against%20a%20warm%20sunset%20sky%20with%20glowing%20orange%20light%2C%20dramatic%20manga%20cover%20illustration%2C%20dynamic%20action%20pose%2C%20cream%20and%20coral%20color%20palette%2C%20clean%20bold%20linework&width=480&height=640&seq=cover-02&orientation=portrait',
  },
  {
    id: 3,
    title: '春日料理屋',
    category: '治愈日常',
    tag: '美食暖胃',
    description: '街角一间只开在春天的小料理屋，主厨用一盘盘家常料理，慢慢治愈每一位疲惫客人心底的褶皱。',
    chapters: 72,
    rating: '9.0',
    fans: '18.9万',
    progress: '第51话',
    cover: 'https://readdy.ai/api/search-image?query=A%20cozy%20spring%20cafe%20kitchen%20with%20steaming%20warm%20bowls%20of%20noodles%20and%20flowers%2C%20soft%20warm%20lighting%2C%20heartwarming%20slice%20of%20life%20manga%20cover%2C%20cream%20and%20gentle%20orange%20palette%2C%20gentle%20clean%20linework%2C%20comfortable%20and%20quiet%20mood&width=480&height=640&seq=cover-03&orientation=portrait',
  },
  {
    id: 4,
    title: '雾都侦探社',
    category: '悬疑推理',
    tag: '烧脑谜案',
    description: '终年笼罩在薄雾中的旧城，侦探与搭档在小酒馆里接下一个个离奇委托，在真相与谎言之间抽丝剥茧。',
    chapters: 110,
    rating: '9.3',
    fans: '24.1万',
    progress: '第73话',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20foggy%20old%20town%20alley%20with%20warm%20street%20lamp%20light%2C%20suspenseful%20manga%20cover%20illustration%2C%20moody%20but%20warm%20color%20palette%2C%20clean%20bold%20linework&width=480&height=640&seq=cover-04&orientation=portrait',
  },
  {
    id: 5,
    title: '花与少年',
    category: '青春恋爱',
    tag: '甜度满分',
    description: '转学第一天，她误把教室后排那个沉默的男生当成了图书馆管理员。一段关于花、约定与心动的青春就此展开。',
    chapters: 84,
    rating: '9.2',
    fans: '30.5万',
    progress: '第58话',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20school%20scene%20with%20a%20boy%20and%20girl%20under%20a%20cherry%20blossom%20tree%2C%20soft%20warm%20afternoon%20light%2C%20sweet%20romance%20manga%20cover%2C%20cream%20and%20coral%20and%20soft%20green%20palette%2C%20clean%20delicate%20linework&width=480&height=640&seq=cover-05&orientation=portrait',
  },
  {
    id: 6,
    title: '机械之心',
    category: '未来机甲',
    tag: '硬核科幻',
    description: '当整座城市的心脏是一台不断运转的巨型机械，一名维修学徒却意外发现了藏在齿轮深处的秘密。',
    chapters: 132,
    rating: '9.0',
    fans: '19.7万',
    progress: '第90话',
    cover: 'https://readdy.ai/api/search-image?query=A%20young%20mechanic%20inside%20a%20giant%20steampunk%20machine%20city%20with%20glowing%20amber%20gears%2C%20warm%20golden%20industrial%20light%2C%20sci-fi%20manga%20cover%20illustration%2C%20cream%20and%20orange%20palette%2C%20clean%20bold%20linework&width=480&height=640&seq=cover-06&orientation=portrait',
  },
  {
    id: 7,
    title: '山海食堂',
    category: '奇幻美食',
    tag: '异兽相伴',
    description: '开在山海之间的深夜食堂，专为迷路的异兽与旅人烹制家乡味道，每一道菜背后都藏着一个妖怪的故事。',
    chapters: 66,
    rating: '9.5',
    fans: '28.4万',
    progress: '第45话',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20mountain%20night%20food%20stall%20with%20cute%20mythical%20spirits%20and%20steaming%20hot%20dishes%2C%20warm%20glowing%20lanterns%2C%20whimsical%20fantasy%20manga%20cover%2C%20cream%20and%20coral%20palette%2C%20clean%20charming%20linework&width=480&height=640&seq=cover-07&orientation=portrait',
  },
  {
    id: 8,
    title: '夜行列车',
    category: '惊悚悬疑',
    tag: '暗夜迷局',
    description: '末班列车驶入未知的站点，乘客们相继醒来却发现记忆彼此交错。谁在说谎，谁才是真正的乘客？',
    chapters: 58,
    rating: '8.8',
    fans: '12.6万',
    progress: '第38话',
    cover: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20night%20train%20carriage%20with%20shadowy%20figures%20and%20warm%20lamp%20glow%2C%20mysterious%20thriller%20manga%20cover%2C%20dramatic%20warm%20and%20dark%20contrast%2C%20clean%20bold%20linework&width=480&height=640&seq=cover-08&orientation=portrait',
  },
];

export interface TestimonialItem {
  id: number;
  name: string;
  role: string;
  avatar: string;
  quote: string;
}

export const testimonialList: TestimonialItem[] = [
  {
    id: 1,
    name: '林小满',
    role: '通勤党 · 手机阅读',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20avatar%20of%20a%20friendly%20young%20woman%20with%20warm%20smile%2C%20cream%20background%2C%20minimal%20clean%20style&width=200&height=200&seq=avatar-01&orientation=squarish',
    quote: '上班路上用手机看，回家换平板接着看，尾巴漫画网自动接上上次的位置，一个字都不用重翻，太省心了。',
  },
  {
    id: 2,
    name: '陈子昂',
    role: '追更党 · 多设备切换',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20avatar%20of%20a%20young%20man%20wearing%20glasses%20with%20friendly%20look%2C%20cream%20background%2C%20minimal%20clean%20style&width=200&height=200&seq=avatar-02&orientation=squarish',
    quote: '书架和收藏在手机、平板、电脑之间完全同步，追的每一部都不会丢，断点续读让我通勤路上随时开刷。',
  },
  {
    id: 3,
    name: '许梦瑶',
    role: '学生党 · 夜读',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20flat%20illustration%20avatar%20of%20a%20cheerful%20young%20girl%20with%20long%20hair%2C%20cream%20background%2C%20minimal%20clean%20style&width=200&height=200&seq=avatar-03&orientation=squarish',
    quote: '每晚关灯前刷几话，历史记录和阅读足迹都清清楚楚，第二天换台设备接着看也完全无压力。',
  },
];

export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    id: 1,
    question: '阅读书签会自动保存吗？',
    answer: '会。尾巴漫画网在您每次翻页后都会自动记录当前阅读位置并生成书签，无需手动操作。即使中途退出，下次打开也会直接回到上次看到的那一页，真正做到断点续读。',
  },
  {
    id: 2,
    question: '跨设备同步怎么使用？',
    answer: '您只需在手机、平板、电脑等设备上使用同一个账号登录尾巴漫画网，阅读进度、书架收藏与历史记录会自动实时同步。换设备后打开任意一部作品，都能接着上次的位置继续阅读。',
  },
  {
    id: 3,
    question: '我的阅读历史和足迹会保存多久？',
    answer: '只要账号保持登录，阅读历史与阅读足迹会持续为您保存。您可以在设置中随时管理、清理或关闭历史记录，相关操作立即生效并同步到所有设备。',
  },
  {
    id: 4,
    question: '收藏的书目会不会因为换设备而丢失？',
    answer: '不会。收藏的书目会与您的账号绑定并跨设备同步，无论在哪台设备登录，收藏都不丢失，全部作品保持完整。',
  },
  {
    id: 5,
    question: '尾巴漫画网支持哪些设备？',
    answer: '尾巴漫画网支持手机、平板与电脑等多端访问，各端体验一致，阅读进度实时互通。无论您用哪台设备，打开尾巴漫画网，阅读进度随时跟着走。',
  },
  {
    id: 6,
    question: '阅读数据是否安全？',
    answer: '尾巴漫画网非常重视您的数据安全，阅读书签、历史记录等数据均经过加密存储与传输，仅您本人可见，请放心使用。',
  },
];